import React, { useContext } from "react";
import NoData from "../../NewComponents/NoData";
import { DataContext } from "../../Context/DataContext";
import { InstantSearch } from "react-instantsearch-hooks-web";
import { searchClientAlgolia } from "../../firebase.config";
import OrdersBackendComponent from "./OrdersComponent";

const OrdersBackend = ({ windowSize }) => {

  const { userData } = useContext(DataContext);

  if(!userData){
    return <NoData loading={true} showBtn={false} loadingText={"invoices"} type="quotes"/>
  }

  return (
     <>
      {/* <TopBar /> */}
    <InstantSearch searchClient={searchClientAlgolia} indexName="orders" >
      <OrdersBackendComponent windowSize={windowSize}/>
      </InstantSearch>
    </>
  );
};

export default OrdersBackend;
